// extracted by mini-css-extract-plugin
export default {"root":"_3t4VR","logo":"_2sYW3","title":"_1httW","logoWrapper":"_1DsbF","navLink":"_2x8Q_","active":"_1_2se"};